import API from '@/lib/API.js'
import comun from './comun.js'
const micrositioefectores = {
    namespaced: true,
    state: {
        Loading: 0,
        Usuario: undefined,
        Roles: [],
        SitiosdelUsuario: [],
        CambioContrasena: false,
    },
    mutations: {
        cargando(state) {
            state.Loading++;
        },
        fincarga(state) {
            state.Loading--;
        },
        selectUsuario(state, valor) {
            state.Usuario = valor;
        },
    },
    actions: {
        async loguear({
            commit
        }, values) {
            commit("cargando")
            let data = []
            //data = await API.Usuarios.traerUser(valor.usuario, valor.contrasena);
            data = await API.Usuarios.LoguearEfector(values.email, values.password);
            if (data && data.Token) {
                window.localStorage.setItem('user', JSON.stringify(data));
                commit("selectUsuario", data)
            } else {
                commit("selectUsuario", undefined)
                alert("Usuario y/o Contraseña incorrecta")
            }
            commit("fincarga")
            return 0;
        },
        async logout({
            commit
        }, valor) {
            commit("cargando")
            localStorage.removeItem('user')
            localStorage.removeItem('permisos')
            commit("selectUsuario", undefined)
            commit("fincarga")
        },
        async selectUsuario({
            commit
        }, valor) {
            commit("cargando")
            commit("selectUsuario", valor)
            commit("fincarga")
        },
        async inicializar({
            commit
        }) {
            commit("cargando")
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                commit("selectUsuario", user)
            }
            commit("fincarga")
        },
    },
}
export default micrositioefectores;